import type { ProviderContext } from "notistack";

import { StoppageDto } from "../../DTOs/Stoppage/StoppageDto";
import { stoppagesMutations } from "../../offline/stoppagesMutations";
import i18n from "../../i18n";

interface StoppagesPage {
  enqueueSnackbar: ProviderContext["enqueueSnackbar"];
  updateRowSource: (isRow: (row: StoppageDto) => boolean, row: StoppageDto) => void;
}

export const saveStoppage = async (stoppage: StoppageDto, { enqueueSnackbar, updateRowSource }: StoppagesPage) => {
  if (!stoppage.stoppageId) {
    enqueueSnackbar(i18n.t("messages.invalidStoppage", { ns: "stoppages" }), { variant: 'error', autoHideDuration: 3000 });
    return;
  }

  const response = await stoppagesMutations.updateStoppage(stoppage).catch(() => null);

  if (!response?.success || !response.data) {
    const errors: { description: string }[] = response?.errors?.length ? response.errors : [{ description: i18n.t("messages.updateFailed", { ns: "stoppages" }) }];
    errors.forEach((error, index) => {
      enqueueSnackbar(error.description, { variant: 'error', autoHideDuration: 5000 + index * 1500 });
    });
    return;
  }

  enqueueSnackbar(i18n.t("messages.updated", { ns: "stoppages" }), { variant: 'success', autoHideDuration: 3000 });
  updateRowSource(row => row.stoppageId === stoppage.stoppageId, response.data);
};
